export default "__VITE_ASSET__BdbueNYa__"